<template>
  <Card>
    <span slot="title">医生标签管理</span>
    <el-button slot="btn" icon="el-icon-refresh" @click="$refresh(getLabelsData)">刷新</el-button>
    <div slot="content" class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="标签名称">
            <el-input v-model="searchForm.name" placeholder="请输入医生标签名称"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getLabelsData, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getLabelsData, { name: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button icon="el-icon-plus" type="primary" @click="addLabel">新增医生标签</el-button>
        <el-button icon="el-icon-delete" type="danger" @click="deletedoctorLabelList">批量删除</el-button>
      </div>
      <!-- 医生标签列表 -->
      <el-table v-loading="loading" :data="doctorLabelList" ref="multipleTable"
        :max-height="tableHeight" @selection-change="val => $handleSelectionChange(val, true)" border>
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="name" label="标签名称"/>
        <el-table-column prop="sortNum" label="显示顺序"/>
        <el-table-column prop="createTime" label="创建时间" min-width="150"/>
        <el-table-column prop="updateTime" label="更新时间" min-width="150"/>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button icon="el-icon-edit" type="primary" @click="editLabel(scope.row)" >编辑</el-button>
            <el-button icon="el-icon-delete" type="danger" @click="deleteLabel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="dialogEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="340px" :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" :rules="editFormRules" inline>
          <el-form-item label="标签名称" prop="name">
            <el-input v-model="editForm.name" placeholder="请输入医生标签名称"/>
          </el-form-item>
          <el-form-item label="显示顺序" prop="sortNum"> 
            <el-input-number style="width: 100%;" v-model="editForm.sortNum" :min="1" step-strictly="true" placeholder="请输入显示顺序"></el-input-number>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-if="dialogTitle == '新增医生标签'" @click="addSave">保存新增</el-button>
          <el-button type="success" v-if="dialogTitle == '编辑医生标签'" @click="editSave">保存修改</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getLabelsData)" :total="total"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"/>
    </div>
  </Card>
</template>

<script lang="js">
import { doctorLabelList, doctorLabelEdit, doctorLabelDelete, doctorLabelAdd } from "@/api/doctorlabel"; // 医生标签请求
export default {
  data() {
    return {
      loading: true, // 加载中
      searchForm: { name: null }, // 查询表单
      doctorLabelList: [], // 医生标签列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogTitle: null, // 弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 新增或编辑表单
      multipleSelection: [], // 被选中行
      editFormRules: {
        name: [{required: true, message: "医生标签名称不能为空", trigger: "blur"}],
        sortNum: [{required: true, message: "显示顺序不能为空", trigger: "blur"}],
        type: [{required: true, message: "请选择医生标签类型", trigger: "change"}]
      }, // 验证规则
      tableHeight: 0, // 表格高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.getLabelsData(); // 页面初始化获取医生标签列表
  },
  methods: {
    // 请求所有医生标签列表
    async getLabelsData() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await doctorLabelList(params);
      if (code == 200) {
        this.total = total;
        this.doctorLabelList = rows;
      }
      this.loading = false;
    },
    // 新增医生标签
    addLabel() {
      this.dialogVisible = true;
      this.dialogTitle = "新增医生标签";
      this.editForm = { name: null,sortNum: null };
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          doctorLabelAdd(this.editForm).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("新增医生标签成功！");
            this.dialogVisible = false;
            this.$refresh(this.getLabelsData);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 删除医生标签
    deleteLabel(row) {
      this.$confirm('确认删除该医生标签？').then(_ => { this.del(row.doctorLabelId) }).catch(_ => {});
    },
    async del(id) {
      let { code } = await doctorLabelDelete(id);
      if (code == 200) this.$message.success("删除医生标签成功！");
      this.$refresh(this.getLabelsData);
    },
    // 批量删除医生标签
    deletedoctorLabelList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何医生标签");
      else {
        selected.forEach(item => { selectedId.push(item.doctorLabelId) });
        this.$confirm('确认删除该医生标签？').then(_ => { this.del(selectedId) }).catch(_ => {});
      }
    },
    // 编辑医生标签信息
    async editLabel(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.dialogTitle = "编辑医生标签";
      this.dialogVisible = true;
    },
    // 保存医生标签修改
    editSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          doctorLabelEdit(this.editForm).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("修改医生标签成功！");
            this.dialogVisible = false;
            this.$refresh(this.getLabelsData);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    }
  },
};
</script>